import { SEC_ApiCall, SEC_DataApiPost } from '../func';

/**
 * Load BOOKINGSTS bookings and room metadata for a single date.
 * @param {string} date - Date in yyyy-mm-dd format.
 * @returns {Promise<object>} Day payload including rooms metadata and bookings.
 */
export async function getBookingTsDay(date) {
    return SEC_ApiCall('bookingsts/day', { date });
}

/**
 * Submit a new BOOKINGSTS booking.
 * @param {object} payload - Booking request body.
 * @returns {Promise<object>} API response payload.
 */
export async function createBookingTs(payload) {
    return SEC_DataApiPost('bookingsts/create', JSON.stringify(payload), {});
}

/**
 * Cancel an existing BOOKINGSTS booking.
 * @param {object} payload - Cancel request body.
 * @returns {Promise<object>} API response payload.
 */
export async function cancelBookingTs(payload) {
    return SEC_DataApiPost('bookingsts/cancel', JSON.stringify(payload), {});
}

/**
 * Get available transfer destination rooms for an existing booking.
 * @param {object} params - Query payload with date, roomGuid and bookingGuid.
 * @returns {Promise<object>} API response payload containing `items`.
 */
export async function getBookingTsTransferOptions(params) {
    return SEC_ApiCall('bookingsts/transfer', params);
}

/**
 * Transfer an existing BOOKINGSTS booking to another room.
 * @param {object} payload - Transfer request body.
 * @returns {Promise<object>} API response payload.
 */
export async function transferBookingTs(payload) {
    return SEC_DataApiPost('bookingsts/transfer', JSON.stringify(payload), {});
}

/**
 * Check whether a room slot is available for booking transfer/edit validation.
 * @param {object} params - Query payload with date, roomGuid, bookingGuid, targetRoomGuid, startTime and endTime.
 * @returns {Promise<object>} API response payload.
 */
export async function checkBookingTsAvailability(params) {
    return SEC_ApiCall('bookingsts/transfer', params);
}

/**
 * Edit an existing BOOKINGSTS booking.
 * @param {object} payload - Edit request body.
 * @returns {Promise<object>} API response payload.
 */
export async function editBookingTs(payload) {
    return SEC_DataApiPost('bookingsts/edit', JSON.stringify(payload), {});
}
